module.exports = __webpack_public_path__ + "img/logo.83c50365.png";